import "./page_header.css";
import { useItems } from "../../contexts/item_context";

export default function TitleBar() {
    const { addNewItem } = useItems();

    return (
        <div className="title-bar">
            <span className="title-bar__label">FILES</span>
            <button
                className="title-bar__new-btn"
                onClick={addNewItem}
                title="New File"
                type="button"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="12" y1="11" x2="12" y2="17" />
                    <line x1="9" y1="14" x2="15" y2="14" />
                </svg>
            </button>
        </div>
    );
}
